import { useEffect, useRef, useState } from "react";

// Бір басумен таңдалатын себептер (1–8 пернелері де таңдайды).
export const REJECT_REASONS = [
  "Спам",
  "Неподходящий контент",
  "Некорректная информация",
  "Дубликат",
  "Нарушение правил",
  "Плохое фото / нет фото",
  "Неверная категория",
  "Контакты в описании",
];

/** Причина + необязательный комментарий → текст, который увидит автор. */
export function composeRejectMessage(reason, comment) {
  const c = comment.trim();
  if (reason && c) return `${reason}: ${c}`;
  return c || reason;
}

export default function RejectReasonPicker({ onConfirm, onCancel, busy = false, confirmLabel = "Отклонить" }) {
  const [reason, setReason] = useState("");
  const [comment, setComment] = useState("");
  const rootRef = useRef(null);
  const message = composeRejectMessage(reason, comment);

  useEffect(() => {
    rootRef.current?.focus();
  }, []);

  const submit = () => {
    if (message && !busy) onConfirm(message);
  };

  const onKeyDown = (e) => {
    e.stopPropagation(); // модальдың/тізімнің тіркесімдері іске қосылмасын
    if (e.key === "Escape") {
      e.preventDefault();
      onCancel();
      return;
    }
    if (e.key === "Enter" && (e.metaKey || e.ctrlKey)) {
      e.preventDefault();
      submit();
      return;
    }
    const typing = e.target.tagName === "TEXTAREA";
    if (!typing && /^[1-8]$/.test(e.key)) {
      const r = REJECT_REASONS[Number(e.key) - 1];
      setReason((prev) => (prev === r ? "" : r));
    }
    if (!typing && e.key === "Enter") {
      e.preventDefault();
      submit();
    }
  };

  return (
    <div
      ref={rootRef}
      tabIndex={-1}
      onKeyDown={onKeyDown}
      className="space-y-3 rounded-lg border border-rose-500/40 bg-rose-500/[0.06] p-3 outline-none"
    >
      <div className="text-sm font-medium text-text-primary">Причина отклонения</div>
      <div className="flex flex-wrap gap-2">
        {REJECT_REASONS.map((r, i) => {
          const active = reason === r;
          return (
            <button
              key={r}
              type="button"
              onClick={() => setReason(active ? "" : r)}
              className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-medium transition-colors ${
                active
                  ? "border-rose-500 bg-rose-500 text-white"
                  : "border-border-primary text-text-secondary hover:border-rose-400 hover:text-text-primary"
              }`}
            >
              <kbd className={`text-[10px] ${active ? "text-white/80" : "text-text-muted"}`}>{i + 1}</kbd>
              {r}
            </button>
          );
        })}
      </div>
      <textarea
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        rows={2}
        placeholder="Комментарий для автора (необязательно)"
        className="w-full resize-none rounded-lg border border-border-primary bg-bg-card p-2.5 text-sm text-text-primary placeholder:text-text-muted focus:border-rose-400 focus:outline-none focus:ring-2 focus:ring-rose-400/40"
      />
      {message && (
        <div className="text-xs text-text-muted">
          Автор увидит: <span className="text-text-secondary">«{message}»</span>
        </div>
      )}
      <div className="flex items-center justify-end gap-2">
        <span className="mr-auto hidden text-[11px] text-text-muted sm:inline">1–8 — причина · Enter — отклонить · Esc — отмена</span>
        <button
          type="button"
          onClick={onCancel}
          className="rounded-lg px-3 py-2 text-sm font-medium text-text-secondary hover:bg-bg-tertiary"
        >
          Отмена
        </button>
        <button
          type="button"
          onClick={submit}
          disabled={!message || busy}
          className="rounded-lg bg-rose-600 px-4 py-2 text-sm font-semibold text-white hover:bg-rose-700 disabled:cursor-not-allowed disabled:opacity-50"
        >
          {busy ? "Отклоняем…" : confirmLabel}
        </button>
      </div>
    </div>
  );
}
